module.exports = __webpack_public_path__ + "static/media/team-rocket-intro-2.db793e01.wav";